// base
import React from 'react';

// styles
import {
  StyledCredentialCard,
  StyledCredentialCardTable,
  StyledCredentialCardTableBody,
  StyledCredentialCardTableHeader,
  StyledCredentialCardTableRow
} from './style';

// components
import { BasicTextField, SingleDatepicker } from 'components';
import dayjs from 'dayjs';
import { stringToDate } from 'utils';

interface CredentialCardProps {
  iqamaNo: string;
  setIqamaNo: (value: string) => void;
  passportNo: string;
  setPassportNo: (value: string) => void;
  gatepassNo?: string;
  setGatepassNo?: (value: string) => void;
  iqamaExpiryDate?: string;
  setIqamaExpiryDate?: (value: string) => void;
  passportExpiryDate?: string;
  setPassportExpiryDate?: (value: string) => void;
  gatepassExpiryDate?: string;
  setGatepassExpiryDate?: (value: string) => void;
  disabled?: boolean;
}

export const CredentialCard: React.FC<CredentialCardProps> = ({
  disabled = false,
  iqamaNo,
  setIqamaNo,
  iqamaExpiryDate,
  setIqamaExpiryDate,
  passportNo,
  setPassportNo,
  passportExpiryDate,
  setPassportExpiryDate,
  gatepassNo,
  setGatepassNo,
  gatepassExpiryDate,
  setGatepassExpiryDate
}) => {
  return (
    <StyledCredentialCard>
      <StyledCredentialCardTable>
        <StyledCredentialCardTableHeader>
          <div>Type</div>
          <div>Number</div>
          <div>Expiry Date</div>
        </StyledCredentialCardTableHeader>
        <StyledCredentialCardTableBody>
          <StyledCredentialCardTableRow>
            <div className="row type iqama">
              <p>
                Iqama <span className="required">*</span>
              </p>
            </div>
            <div className="row number iqama">
              <BasicTextField
                inputProps={{
                  style: {
                    padding: '6.5px 12px'
                  }
                }}
                placeholder="Enter Iqama No"
                value={iqamaNo}
                onChange={(e) => setIqamaNo(e.target.value)}
              />
            </div>
            <div className="row date iqama">
              <SingleDatepicker
                initialDate={stringToDate(iqamaExpiryDate)}
                onChange={(date) => {
                  if (date) {
                    setIqamaExpiryDate?.(dayjs(date).format('YYYY-MM-DD'));
                  }
                }}
              />
            </div>
          </StyledCredentialCardTableRow>

          <StyledCredentialCardTableRow>
            <div className="row type passport">
              <p>Passport</p>
            </div>
            <div className="row number passport">
              <BasicTextField
                inputProps={{
                  style: {
                    padding: '6.5px 12px'
                  }
                }}
                placeholder="Enter Passport No"
                value={passportNo}
                onChange={(e) => setPassportNo(e.target.value)}
              />
            </div>
            <div className="row date passport">
              <SingleDatepicker
                initialDate={stringToDate(passportExpiryDate)}
                onChange={(date) => {
                  if (date) {
                    setPassportExpiryDate?.(dayjs(date).format('YYYY-MM-DD'));
                  }
                }}
              />
            </div>
          </StyledCredentialCardTableRow>

          <StyledCredentialCardTableRow>
            <div className="row type gatepass">
              <p>Gatepass</p>
            </div>
            <div className="row number gatepass">
              <BasicTextField
                inputProps={{
                  style: {
                    padding: '6.5px 12px'
                  }
                }}
                placeholder="Enter Gatepass No"
                value={gatepassNo}
                onChange={(e) => setGatepassNo?.(e.target.value)}
              />
            </div>
            <div className="row date gatepass">
              <SingleDatepicker
                initialDate={stringToDate(gatepassExpiryDate)}
                onChange={(date) => {
                  if (date) {
                    setGatepassExpiryDate?.(dayjs(date).format('YYYY-MM-DD'));
                  }
                }}
              />
            </div>
          </StyledCredentialCardTableRow>
        </StyledCredentialCardTableBody>
      </StyledCredentialCardTable>
    </StyledCredentialCard>
  );
};
